import * as t from 'io-ts';
import { BookingDynamicType } from './booking';

export const BookingsListDynamicType = t.interface({
    bookings: t.array(BookingDynamicType)
});

export type BookingsList = t.TypeOf<typeof BookingsListDynamicType>;
